import * as types from 'store/modules/hrms13x/mutation-types'
import hrms13x from 'api/hrms13x'
import stdemp from 'api/stdemp'
import swal from 'sweetalert'
import hrms13xLabels from 'assets/labels/hrms13x'
import stdempLabels from 'assets/labels/stdemp'
import { hrms13xColumns } from 'assets/columns/hrms13x'
import configLabel from 'src/../config/label'
import axios from 'axios'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: {
      en: Object.assign(hrms13xLabels.en, stdempLabels.en),
      th: Object.assign(hrms13xLabels.th, stdempLabels.th)
    },
    columns: hrms13xColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        total: 0,
        rows: []
      },
      tab3: {
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab4: {
        total: 0,
        rows: []
      },
      tab5: {
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        },
        table3: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: {},
    listFields: {
      en: [],
      th: []
    }
  },
  getters: {
    [types.GET_HRMS13X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS13X_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS13X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS13X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS13X_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS13X_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS13X_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS13X_LISTFIELDS] (state) {
      return state.listFields
    }
  },
  mutations: {
    [types.SET_HRMS13X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS13X_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS13X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].tab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab2, labels[keyLang])
        state.columns[keyLang].tab3table1 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab3table1, labels[keyLang])
        state.columns[keyLang].tab3table2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab3table2, labels[keyLang])
        state.columns[keyLang].tab4 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab4, labels[keyLang])
      }
    },
    [types.SET_HRMS13X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS13X_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS13X_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS13X_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS13X_LISTFIELDS] (state, data) {
      state.listFields = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS13X_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS13X_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS13X_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS13X_COLUMNS_LABELS] ({ commit }) {
      axios.all([
        hrms13x.getLabels(),
        stdemp.getLabels()
      ])
      .then(axios.spread(function (responseLabels, responseLabelsStdemp) {
        const dataHrms13x = JSON.parse(responseLabels.request.response)
        const dataStdemp = JSON.parse(responseLabelsStdemp.request.response)
        let labels = {}
        labels.en = Object.assign(dataHrms13x.labels.en, dataStdemp.labels.en)
        labels.th = Object.assign(dataHrms13x.labels.th, dataStdemp.labels.th)
        commit(types.SET_HRMS13X_COLUMNS, labels)
        commit(types.SET_HRMS13X_LABELS, labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRMS13X_INDEX] ({ commit }, searchParams) {
      hrms13x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS13X_INDEX, data)
        })
        .catch((response) => {
          const data = response.response.data
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS13X_INDEX, objData)
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS13X_DETAIL] ({ commit }, searchParams) {
      hrms13x.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS13X_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS13X_LISTFIELDS] ({ commit }, searchParams) {
      hrms13x.getListFields()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS13X_LISTFIELDS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms13x/index.js